import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ConvocatoriaAyudantiasDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ConvocatoriaAyudantiasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }
  // convocatoria por escuela y flujo de trabajo
  getConvocatoriaAyudantiasPorEscuelaFlujoTrabajoService(codigoEscuela: string, ordenFlujoTrabajo: string): Observable<BodyListResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias/escuela/flujo/' + codigoEscuela + '/' + ordenFlujoTrabajo);
  }


  // buscar convocatorias de ayudantias por escuela
  getConvocatoriaAyudantiasPorEscuelaService(codigoEscuela: string): Observable<BodyListResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias/escuela/' + codigoEscuela);
  }

  getConvocatoriaAyudantiasService(): Observable<BodyListResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias/todos');
  }

  getConvocatoriaAyudantiasActivasService(): Observable<BodyListResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias');
  }

  guardarConvocatoriaAyudantiasService(convocatoriaAyudantiasDTO: ConvocatoriaAyudantiasDTO): Observable<BodyResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/convocatoriaAyudantias', convocatoriaAyudantiasDTO);
  }

  getConvocatoriaAyudantiasPorCodigoService(codigo: string): Observable<BodyResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias/' + codigo);
  }

  /**** */
  guardarConvocatoriaAyudantiasFlujoTrabajoService(convocatoriaAyudantiasDTO: ConvocatoriaAyudantiasDTO, flujo: string): Observable<BodyResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/convocatoriaAyudantias/guardar/flujo/' + flujo, convocatoriaAyudantiasDTO);
  }

  getConvocatoriaAyudantiasPorCodigoConvocatoriaOrdenService(orden: string): Observable<BodyListResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias/orden/' + orden);
  }

  /** obtener convocatorias por fechas */

  obtenerConvocatoriasPorFecha(codigoEstudiante:string): Observable<BodyListResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias/validacionFechas/'+codigoEstudiante);
  }


  obtenerConvocatoriaPorEstadoPublicacion(estadoPublicacion: string): Observable<BodyListResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias/estadoPublicacion/' + estadoPublicacion);
  }

  obtenerConvocatoriasPorFlujoTrabajoEstado(codigoUnico: string, codigoEscuela: string): Observable<BodyListResponse<ConvocatoriaAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvocatoriaAyudantiasDTO>>(API_URL + '/api/v1/convocatoriaAyudantias/obtenerFlujoTrabajo/' + codigoUnico + '/' + codigoEscuela);
  }
  obtenerPostulacionesRevision(codigoEscuela: string): Observable<BodyResponse<boolean>> {
    return this.http.get<BodyResponse<boolean>>(API_URL + '/api/v1/convocatoriaAyudantias/validarPostulacion/' + codigoEscuela);
  }

}
